export enum VisualizationType {
  SIMPLE,
  PRETTY,
  EXPANDABLE,
  HIGHLIGHT
}
